module.exports = __webpack_public_path__ + "static/outdoor-d38e1b2a080a654ba115a235722f8b28.svg";